<template>
    <base-file-input
        ref="emirates-id"
        v-model="model"
        v-validate="{
            // required: isRequiredByprofileType,
        }"
        input-id="emirates-id"
        :required="isRequiredByprofileType || isfileInputRequired()"
        :field="field"
        :input-label="labelId"
        :placeholder="
            originalFileName || 'Select scan copy (JPG, PNG, PDF or TIFF file)'
        "
        drop-placeholder="Drop file here..."
        file-type="utility"
        :disabled="loading || isDisabled"
        accept="image/*,application/pdf"
        :data-vv-name="labelId"
        :class="{
            'is-invalid': errors.has(labelId),
        }"
        @update:originalFileName="updateOriginalFileName"
    ></base-file-input>
</template>

<script>
import IdentityDocument from './IdentityDocument'
import {mapGetters, mapMutations} from 'vuex'
export default {
    // End of Component > inject

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {},
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: IdentityDocument, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > inject
    |--------------------------------------------------------------------------
    */
    inject: {}, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        field: {
            type: Object,
            default() {
                return {
                    isRequired: true,
                    isLocked: true,
                    key: 'documentInfo.fieldEmiratesID.fileName',
                    originalFileNameKey:
                        'documentInfo.fieldEmiratesID.originalFileName',
                }
            },
            required: false,
        },
        profileType: {
            type: String,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            // model:'',
            isDisabled:false,
            fieldsToCheck:[
                {
                    field:'documentInfo.scrutiny.fileName',
                    dependency:'accountInfo.enhancedDueDiligence.isScrutinyPerformed'
                },
                {
                    field:'documentInfo.custBusInquired.fileName',
                    dependency:'accountInfo.enhancedDueDiligence.isCustBusInquired'
                },
                {
                    field:'documentInfo.managementApproval.fileName',
                    dependency:'accountInfo.enhancedDueDiligence.isManagementApproval'
                },
                {
                    field:'documentInfo.firstPayment.fileName',
                    dependency:'accountInfo.enhancedDueDiligence.isFirstPayment'
                },
            ]
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        // isRequiredByprofileType() {
        //     if (this.profileType != 'Non-resident (tourist)') {
        //         this.field.isRequired = true
        //         return this.field.isRequired
        //     } else {
        //         this.field.isRequired = false
        //         return this.field.isRequired
        //     }
        // },
        ...mapGetters(['form']),
        labelId() {
            if(this.field.section !="account-info"){
                    if(this.$route.name=="self-registration-company-upload-document" || this.$store.getters.form.type=='company')
                    {
                        return "Memorandum of Association"
                    }
                
                    else
                    {
                        return 'ID Document Front Scan Copy'
                    }
            }
            else{
                  return this.field.label
            }
        }
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        
        const fieldFound = this.fieldsToCheck.find(fieldObj => fieldObj.field === this.field.key);
        if(fieldFound)
        {
            let fieldName = fieldFound.dependency.split('.')
            let condition = ""

            if(fieldName[0]=='accountInfo')
            {
                condition=this.customToLowerCase(this.$store.state.registration.form[fieldName[0]][fieldName[1]])=='yes' || 
                          ( fieldName.length == 3 && this.customToLowerCase(this.form[fieldName[0]][fieldName[1]][fieldName[2]]) == "yes")
            }
            if(condition)
            {
                this.isDisabled = false//!this.isDisabled
                fieldName.includes('enhancedDueDiligence') ? this.field.isRequired = false : this.field.isRequired = true
            }
            else
            {
                this.isDisabled = true//!this.isDisabled
                this.field.isRequired = false
            }
        }
    }, // End of Component > computed

    created(){
        const fieldFound = this.fieldsToCheck.find(fieldObj => fieldObj.field === this.field.key);

        if (fieldFound) {

            this.$store.watch(
                (state) => {
                    let fieldName = fieldFound.dependency.split('.')
                    return fieldName.length == 3 ? this.form[fieldName[0]][fieldName[1]][fieldName[2]] : this.form[fieldName[0]][fieldName[1]]// could also put a Getter here

                },
                (newValue, oldValue) => {
                    let fieldName = fieldFound.dependency.split('.')
                    let condition = ""
                    if(fieldName[0]=='accountInfo')
                    {
                        condition=this.customToLowerCase(newValue)=='yes'
                    }
                    if(condition){
                    // if (newValue == 'Unable to obtain a TIN/Equivalent Number') {

                        this.isDisabled = false//!this.isDisabled
                        fieldName.includes('enhancedDueDiligence') ? this.field.isRequired = false : this.field.isRequired = true

                    } else {
                        this.$refs['emirates-id'].$refs['file-input'].reset()
                        this.updateField({
                            key:this.field.key,
                            value:null
                        })
                        this.updateField({
                            key:this.field.originalFileNameKey,
                            value:null
                        })
                       
                        this.isDisabled = true//!this.isDisabled
                        this.field.isRequired = false
                    }
                }
            )
           }
           },

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        ...mapMutations(['updateField']),
        customToLowerCase(value){
            return typeof value == 'string' ? value.toLowerCase() : ''
        },
        isfileInputRequired(){
            return (this.$route.name.includes('edit') && this.field.section =="account-info" && this.field.isRequired )
        }
    }, // End of Component > mounted
}
</script>
